/**
 * File: blocks.js
 *
 * Provide carousel functionality for interactive `.modules.blocks`.
 */

// Make sure everything is loaded first.
if (
	( 'complete' === document.readyState ||
		'loading' !== document.readyState ) &&
	! document.documentElement.doScroll
) {
	wdsBlocksCarouselInit();
} else {
	document.addEventListener( 'DOMContentLoaded', wdsBlocksCarouselInit );
}

/**
 * Handle our carousel modules.
 *
 * @since March 30, 2023
 */
function wdsBlocksCarouselInit() {
	const carousels = document.querySelectorAll( '.module.blocks.interactive' );

	carousels.forEach( ( carousel ) => {
		const interactiveCarousel = new BlocksCarousel( carousel );
		interactiveCarousel.init();
	} );
}

class BlocksCarousel {
	constructor( carousel ) {
		this.carousel = carousel;
		this.blockWrapper = carousel.querySelector( '.cards, .columns' );
		this.carouselBlocks = carousel.querySelectorAll( '.card, .column' );
		this.prevButton = carousel.querySelector( 'button.arrow.prev' );
		this.nextButton = carousel.querySelector( 'button.arrow.next' );
		this.currentStep = 0;
		this.offset = 0;
		this.maxStep = this.carouselBlocks.length - 1 || 0;
		this.queryMatchers = undefined;

		this.format = 'columns';
		if ( carousel.querySelector( '.cards' ) ) {
			this.format = 'cards';
		}

		this.size = '';
		if ( carousel.querySelector( '.columns.sm' ) ) {
			this.size = 'SM';
		} else if ( carousel.querySelector( '.columns.md' ) ) {
			this.size = 'MD';
		} else if ( carousel.querySelector( '.columns.lg' ) ) {
			this.size = 'LG';
		}
	}

	init() {
		this.blockWrapper.setAttribute( 'data-step', this.currentStep );
		this.prevButton.addEventListener( 'click', ( event ) =>
			this.handleArrowClick( event, -1 )
		);
		this.nextButton.addEventListener( 'click', ( event ) =>
			this.handleArrowClick( event, 1 )
		);
		this.checkScreenSize();
	}

	handleArrowClick( event, direction ) {
		this.currentStep = parseInt( this.currentStep ) + parseInt( direction );

		this.blockWrapper.setAttribute( 'data-step', this.currentStep );

		if ( this.currentStep <= 0 ) {
			this.currentStep = 0;
			this.prevButton.setAttribute( 'disabled', true );
		} else {
			this.prevButton.removeAttribute( 'disabled' );
		}

		if ( this.currentStep >= this.maxStep ) {
			this.currentStep = this.maxStep;
			this.nextButton.setAttribute( 'disabled', true );
		} else {
			this.nextButton.removeAttribute( 'disabled' );
		}
	}

	checkScreenSize() {
		const that = this;
		const formatSize = `${ that.format }${ that.size }`;

		const queries = {
			cards: {
				'screen and (max-width: 599px)': 0,
				'screen and (min-width: 600px) and (max-width: 989px)': 1,
				'screen and (min-width: 990px)': 2,
			},

			columnsSM: {
				'screen and (max-width: 599px)': 0,
				'screen and (min-width: 600px) and (max-width: 639px)': 3,
				'screen and (min-width: 640px) and (max-width: 759px)': 4,
				'screen and (min-width: 760px) and (max-width: 879px)': 5,
				'screen and (min-width: 880px) and (max-width: 899px)': 6,
				'screen and (min-width: 900px) and (max-width: 1039px)': 5,
				'screen and (min-width: 1040px) and (max-width: 1183px)': 6,
				'screen and (min-width: 1184px) and (max-width: 1199px)': 7,
				'screen and (min-width: 1200px)': 6,
			},

			columnsMD: {
				'screen and (max-width: 599px)': 0,
				'screen and (min-width: 600px) and (max-width: 647px)': 2,
				'screen and (min-width: 648px) and (max-width: 799px)': 3,
				'screen and (min-width: 800px) and (max-width: 899px)': 4,
				'screen and (min-width: 900px) and (max-width: 909px)': 3,
				'screen and (min-width: 910px) and (max-width: 1085px)': 4,
				'screen and (min-width: 1086px)': 5,
			},

			columnsLG: {
				'screen and (max-width: 599px)': 0,
				'screen and (min-width: 600px) and (max-width: 687px)': 1,
				'screen and (min-width: 688px) and (max-width: 989px)': 2,
				'screen and (min-width: 990px)': 3,
			},
		};

		const querySet = queries[ formatSize ];

		if ( ! that.queryMatchers ) {
			that.queryMatchers = {};

			Object.keys( querySet ).forEach( ( mediaQuery ) => {
				that.queryMatchers[ mediaQuery ] =
					window.matchMedia( mediaQuery );
			} );
		}

		function adjustOffset() {
			Object.values( that.queryMatchers ).forEach(
				( queryMatcher, i ) => {
					if ( queryMatcher.matches ) {
						const matchedQuery = Object.keys( that.queryMatchers )[
							i
						];

						that.offset = queries[ formatSize ][ matchedQuery ];

						that.maxStep =
							that.carouselBlocks.length - 1 - that.offset;

						if ( that.currentStep <= 0 ) {
							that.currentStep = 0;
							that.prevButton.setAttribute( 'disabled', true );
						} else {
							that.prevButton.removeAttribute( 'disabled' );
						}

						if ( that.currentStep >= that.maxStep ) {
							that.currentStep = that.maxStep;
							that.nextButton.setAttribute( 'disabled', true );
						} else {
							that.nextButton.removeAttribute( 'disabled' );
						}

						that.blockWrapper.setAttribute(
							'data-step',
							that.currentStep
						);
					}
				}
			);
		}

		Object.keys( that.queryMatchers ).forEach( ( key ) => {
			that.queryMatchers[ key ].addEventListener(
				'change',
				adjustOffset
			);
		} );

		adjustOffset();
	}
}
